import mapSearch from './src/main.vue'
mapSearch.install = function (Vue) {
  Vue.component(mapSearch.name, mapSearch)
}
export default mapSearch
